import { Divider } from "@mui/material";
const CustomDivider = ({ orientation = "horizontal", flexItem = false, sx = {} , size }) => {
  return (
    <Divider
      orientation={orientation}
      flexItem={flexItem}
      sx={{
        ...(orientation === "vertical"
          ? { width: size || {xs:"40px",lg:"70px"}, height: "auto" }
          : { height: size || {xs:"40px",lg:"70px"}, width: "auto" }),
        border: "none", 
        ...sx,
      }}
    />
  );
};



export default CustomDivider;
